// File: src/pages/AboutUsPage.jsx
import React, { useState, useEffect } from "react";
import "../styles/pages/AboutUsPage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ImageSection from "../components/ImageSection";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import {
  MdOutlineLeaderboard,
  MdOutlinePublic,
} from "react-icons/md";
import { PiStrategyBold } from "react-icons/pi";
import { LiaFileContractSolid } from "react-icons/lia";

const SkillsComponent = ({ icon, skill, description }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="col-md-4 mb-4 text-center" style={{ width: "100%" }}>
      <div
        className="bg-light rounded-circle text-dark p-3 d-flex mx-auto"
        style={{ width: "3.1em", height: "3.1em" }}
      >
        {icon && React.createElement(icon, { size: "1.55em", className: "mx-auto" })}
      </div>
      <h4
        className="mt-3"
        style={{ fontSize: isMobile ? ".9em" : ".94em", textAlign: "center" }}
      >
        {skill}
      </h4>
      <p className="mx-auto" style={{ fontSize: isMobile ? ".7em" : ".75em" }}>
        {description}
      </p>
    </div>
  );
};

const AboutUsPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <ImageSection title="About Ezclinicstaffing Healthcare Management" />

      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <div style={{ marginTop: "3.3%" }} />

        <h1
          style={{
            textAlign: "center",
            fontSize: "2em",
            color: "#4c4c4c",
            fontWeight: "bold",
            marginTop: isMobile ? "8%" : "3.3%",
            marginBottom: isMobile ? "5%" : "0",
          }}
        >
          About Ezclinicstaffing
        </h1>

        <div style={{ marginTop: isMobile ? "7.2%" : "4.95%" }} />

        {/* Managing Director — text only (no image) */}
        <div
          className="row"
          style={{ marginBottom: "5.4%", marginLeft: "3.3%", marginRight: "3.3%" }}
        >
          <div className="col-12">
            <h4 style={{ fontWeight: "700", marginTop: isMobile ? "1em" : "0" }}>
              Meet Our Managing Director
            </h4>

            <p
              style={{
                color: "#808080",
                fontWeight: "600",
                fontStyle: "italic",
                marginTop: "3.2%",
                marginBottom: "3.2%",
                fontSize: isMobile ? ".9em" : "",
              }}
            >
              {'"'}Greetings! I am <strong>Abubakar</strong>, a seasoned
              professional with over 20 years of experience as a professional manager. Throughout my career, I've
              contributed to various sectors, including Healthcare Management Systems,
              Financial Services, Retail FMCG, EPC Contracts, and the Public sector.
             
             
            </p>

            {/* Skills grid */}
            <div className="row justify-content-between">
              <div className="col">
                <SkillsComponent
                  icon={MdOutlineHealthAndSafety}
                  skill="Healthcare Management"
                  description="Specialized in healthcare management for legal compliance and strategic growth."
                />
              </div>
              <div className="col">
                <SkillsComponent
                  icon={FaRegMoneyBillAlt}
                  skill="Financial Management"
                  description="Expert in financial analysis, ERP systems (Oracle, SAP-HANA), and corporate finance."
                />
              </div>
              <div className="col">
                <SkillsComponent
                  icon={LiaFileContractSolid}
                  skill="EPC Contracts"
                  description="Experienced in managing EPC contracts in healthcare."
                />
              </div>
            </div>

            <div className="row mt-4 justify-content-between">
              <div className="col">
                <SkillsComponent
                  icon={MdOutlineLeaderboard}
                  skill="Inspirational Leadership"
                  description="Effective leader guiding teams to organizational goals."
                />
              </div>
              <div className="col">
                <SkillsComponent
                  icon={PiStrategyBold}
                  skill="Strategic Planning"
                  description="Proven in developing and executing strategic plans."
                />
              </div>
              <div className="col">
                <SkillsComponent
                  icon={MdOutlinePublic}
                  skill="Public Sector"
                  description="Understands financial management in the healthcare public sector."
                />
              </div>
            </div>
          </div>
        </div>

        {/* CTO section removed as requested */}
      </div>

      <div style={{ marginTop: "5.4%" }} />
      <Footer />
    </>
  );
};

export default AboutUsPage;
